import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { CustomLabel } from 'component/reactSelect/CustomLabel'

const ALL = 'all'

class MenuListLabels extends Component {
  handleRemove = (item) => {
    const newValue = this.props.value.filter(
      (option) => option.value !== item.value && option.value !== ALL
    )
    this.props.onChange(newValue)
  }

  renderSelected = () => {
    const { value } = this.props

    return value.map((option, index) => {
      /* istanbul ignore else */
      if (option.value !== ALL) {
        return (
          <CustomLabel
            key={index}
            option={option}
            handleRemove={(option) => this.handleRemove(option)}
          />
        )
      }
    })
  }

  render() {
    const { value } = this.props

    return (
      <div className='react-select__custom-container react-select__custom-container__in-menu'>
        {Array.isArray(value) && this.renderSelected()}
      </div>
    )
  }
}

MenuListLabels.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
}

export { MenuListLabels }
